export default __webpack_public_path__ + "static/media/fond-arrondi-jaune.1fb60ac8.webp";